<template>
    <div id="article-page" class="container">
        <div class="row">
            <div class="col-lg-8 pl-3 mt-40">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="post-title">
                            {{ article.title }}
                        </h2>
                        <div class="post-meta">
                            <span class="post-date"><i class="fa fa-clock-o"></i> {{ article.creation_date | formatShortDate }}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="entry-content" v-html="article.content"></div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="row pt-3" v-if="recentPostCover && recentPostCover.title">
                    <widget class="widget row most-recent mt-40 p-0 mr-4 ml-lg-0 ml-md-3 ml-sm-3" title="Legfrissebb">
                        <div class="row pad-right-block">
                            <post-small-block class="" color="#000" :data="recentPostCover"></post-small-block>
                        </div>
                        <div class="row">
                            <div class="list-post-block ">
                                <ul class="list-post unstyled pad-right-block">
                                    <post-list-item-small v-for="item in recentPosts" v-bind:data="item" v-bind:key="item.ID">
                                    </post-list-item-small>
                                </ul>
                            </div>
                        </div>
                    </widget>
                </div>
                <div class="row">
                    <widget class="widget row w-fan-page mt-20 p-0 mr-4 ml-lg-0 ml-md-3 ml-sm-3 mr-sm-3 ml-xs-3" title="Kövessen minket">
                        <div class="fb-page pl-0"
                             data-href="https://www.facebook.com/Szekelyfold.ma/"
                             data-width="350"
                             data-hide-cover="true"
                             data-show-facepile="false"></div>
                    </widget>
                </div>
                <div class="row mt-4 mr-0 pr-0 mb-4">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0">
                        <div class="row" v-for="campaign in campaigns" v-bind:data="campaign" v-bind:key="campaign.ID">
                            <campaign :data="campaign" class="w-100 p-3"></campaign>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="mostPopularPostCover && mostPopularPostCover.title">
                    <widget class="widget row most-popular mt-20 p-0 mr-4 ml-lg-0 ml-md-3 ml-sm-3" title="Legnépszerűbb">
                        <div class="row pad-right-block">
                            <post-small-block class="" color="#000" :data="mostPopularPostCover"></post-small-block>
                        </div>
                        <div class="row">
                            <div class="list-post-block">
                                <ul class="list-post unstyled pad-right-block">
                                    <post-list-item-small v-for="item in mostPopularPosts" v-bind:data="item" v-bind:key="item.ID">
                                    </post-list-item-small>
                                </ul>
                            </div>
                        </div>
                    </widget>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PostBlockGroup from "../post/PostBlockGroup";
    import PostSmallBlockHorizontal from "../post/PostSmallBlockHorizontal";
    import PostListItemSmall from "../post/PostListItemSmall";
    import PostSmallBlock from "../post/PostSmallBlock";
    import PostListItem from "../post/PostListItem";
    import Campaign from "../addons/Campaigns";
    import Widget from "../addons/Widget"
    import SinglePostHeader from "../post/SinglePost/SinglePostHeader";
    import SinglePostContent from "../post/SinglePost/SinglePostContent";
    import Tag from '../addons/Tag'
    import Ad from '../addons/Ad'
    import { mapGetters } from 'vuex'

    export default {
        name: 'ArticlePage',
        props: ['data'],
        data() {
            return {
                recentPostCover: this.getRecentPostCover,
                recentPosts: this.getRecentPosts,
                mostPopularPostCover: this.getMostPopularPostCover,
                mostPopularPosts: this.getMostPopularPosts,
                relatedPosts: [
                    {ID: 1, title: '', author: ''},
                    {ID: 2, title: '', author: ''},
                    {ID: 3, title: '', author: ''},
                ],
                campaigns: [

                ],

            }
        },
        components: {
            SinglePostHeader,
            SinglePostContent,
            PostListItemSmall,
            PostSmallBlock,
            PostListItem,
            Campaign,
            Widget,
            PostBlockGroup,
            PostSmallBlockHorizontal,
            Tag,
            Ad
        },
        computed: {
            ...mapGetters([
                'getRecentPostCover',
                'getRecentPosts',
                'getMostPopularPostCover',
                'getMostPopularPosts',
            ]),
            article: {
                get: function() {
                    return this.data ? this.data : {};
                },
                set: function(newVal) {
                    return newVal;
                }
            }
        },
        mounted() {

        },
        watch: {
            data: {
                handler: function(newVal) {
                    this.article = newVal ? {} : newVal;

                    if(newVal) {
                        this.$gtag.event('page', { title: newVal.title, url: newVal.url });
                    }
                },
                deep: true,
                immediate: true,
            },
            getPage: function (newVal) {
                this.page = newVal;
            },
            getRecentPostCover: function (newVal) {
                this.recentPostCover = newVal;
            },
            getRecentPosts: function (newVal) {
                this.recentPosts = newVal;
            },
            getMostPopularPostCover: function (newVal) {
                this.mostPopularPostCover = newVal;
            },
            getMostPopularPosts: function (newVal) {
                this.mostPopularPosts = newVal;
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';

    #article-page {
        .post-title {
            font-size: 30px;
            line-height: 40px;
            padding: 15px 0 8px 0;
            margin: 0;
        }

        .post-meta {
            padding-bottom: 15px;

            span {
                font-size: 12px;
                color: #a3a3a3;
                margin-right: 8px;
                padding-right: 10px;
                border-right: 1px solid #dedede;
                line-height: 12px;
                display: inline-block;

                i {
                    margin-right: 5px;
                }
            }

            .post-author {
                a {
                    color: #1c1c1c;
                    font-weight: 700;
                }
            }

            .post-date {
                border-right: 0;
            }

            .post-edit {
                i, a, span {
                    color: $red;
                }

                a:hover {
                    text-decoration: underline;
                }
            }
        }

        .entry-content {
            font-size: 15px;
            line-height: 26px;
            margin-bottom: 15px;
            text-align: justify;
            padding-top: 20px;

            p {
                font-size: 15px;
                line-height: 26px;
                margin-bottom: 15px;
            }

            .alt {
                background-color: #1c1c1c;
                color: #999;
                font-size: 13px;
                margin-top: 11px;
                padding: 10px;
                width: 100%;
            }

            blockquote {
                background: #f7f7f7;
                border: 0;
                font-family: Arimo, sans-serif;
                font-size: 22px;
                font-weight: 400;
                line-height: 34px;
                margin: 50px 0 40px;
                padding: 45px 50px 30px;
                position: relative;
                text-align: center;

                p {
                    font-weight: 700;
                    background-color: transparent;
                }
            }

            blockquote:before {
                background: #ec0000;
                color: #fff;
                content: '\201C';
                font-family: Georgia, serif;
                font-size: 69px;
                left: 45px;
                margin-left: -44px;
                padding: 30px 10px 0px 10px;
                position: absolute;
                top: -30px;
            }

            .internal-post {
                background: #f7f7f7;
                border-left: 3px solid $red;
                font-family: Arimo, sans-serif;
                font-size: 22px;
                font-weight: 400;
                line-height: 34px;
                margin: 20px 0 20px;
                padding: 15px;
                position: relative;
                text-align: center;

                .img {
                    overflow: hidden;

                    img {
                        width: 130%;
                        height: 150px;
                    }
                }

                .content {
                    text-align: left;

                    a {
                        color: $dark-grey;
                    }

                    a:hover {
                        text-decoration: underline;
                    }

                    .desc {
                        background-color: transparent;
                        padding-top: 10px;
                    }
                }
            }
        }
    }
</style>
